// extracted by mini-css-extract-plugin
export default {"CheckboxGroupPlaceholder":"UXYWhbgz"};